import Repository from '@/repositories/base/Repository';
import AccountsReceivableParams from '@/domain/models/preNegotiations/accountsReceivable/AccountsReceivableParams';

export default class AccountsReceivableParamsRepository extends Repository {
  public async getByCompanyGroupId(
    companyGroupId: number,
    companyIds: number[],
  ): Promise<AccountsReceivableParams|undefined> {
    const { data: response } = await this.datasource.get(
      `company-groups/${companyGroupId}/billings/pre-negotiations/accounts-receivable/params`,
      { headers: { 'company-ids': JSON.stringify(companyIds) } },
    );

    if (!response.data) {
      return undefined;
    }

    return AccountsReceivableParams.make(response.data);
  }
}
